import Model, { ID, IsoDate, MODEL_LEVEL } from 'src/models/model'

export const INDY_PAYOUT_TYPES = ['indy-fee', 'indy-services-fee']

export default class TransferPayout extends Model {
  static name = 'TransferPayout'

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Financial]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      type: {
        type: String,
        output: true
      },
      payoutId: {
        type: String,
        sortable: true,
        output: true
      },
      status: {
        type: String,
        output: true
      },
      statementDescriptor: {
        type: String,
        output: true
      },
      amount: {
        type: Number,
        output: true
      },
      arrivalDate: {
        type: IsoDate,
        output: true
      }
    }

    this.paginate = true
  }
}
